module.exports = __webpack_public_path__ + "media/images/xpass/icons/brands/inactive/kinrgy-aa9ee4792c91c40b6edec5821954b837.png";